import { abbreviateMoney, abbreviateNumber } from "../../../utils/numberFormatting.utils";

const getSalesByHosting = apps => {
  return apps.reduce((previousValue, currentValue) => {
    previousValue.revenue += currentValue.revenue;
    previousValue.salesUnitCount += currentValue.count;
    return previousValue;
  }, {
    revenue: 0,
    salesUnitCount: 0
  });
};

const formatSales = (sales, label) => {
  const {
    revenue,
    salesUnitCount
  } = sales;
  if (!salesUnitCount) return '-';
  const formattedLabel = "".concat(abbreviateMoney(revenue), " (").concat(abbreviateNumber(salesUnitCount), ")");
  return "".concat("".concat(label ? "".concat(label, " - ") : "").concat(formattedLabel));
}; // $FlowFixMe https://ecosystem.atlassian.net/browse/AMKT-27278


const getSalesSummaryByHosting = appSale => {
  // actual value will be required to display in the tooltip
  const appSalesSummary = {
    cloud: {
      revenue: 0,
      salesUnitCount: 0
    },
    server: {
      revenue: 0,
      salesUnitCount: 0
    },
    datacenter: {
      revenue: 0,
      salesUnitCount: 0
    },
    total: {
      revenue: 0,
      salesUnitCount: 0
    }
  };
  const totalSalesForApp = {
    revenue: 0,
    salesUnitCount: 0
  };
  appSale.series.forEach(hostingBasedAppSales => {
    const hostingType = hostingBasedAppSales.name.replace(/ /g, '').toLowerCase();
    const appSalesSummaryForEachHosting = getSalesByHosting(hostingBasedAppSales.elements);
    appSalesSummary[hostingType] = {
      revenue: appSalesSummaryForEachHosting.revenue,
      salesUnitCount: appSalesSummaryForEachHosting.salesUnitCount
    };
    totalSalesForApp.revenue += appSalesSummaryForEachHosting.revenue;
    totalSalesForApp.salesUnitCount += appSalesSummaryForEachHosting.salesUnitCount;
  });
  appSalesSummary.total = totalSalesForApp;
  return appSalesSummary;
};

export { formatSales, getSalesByHosting, getSalesSummaryByHosting };